function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

import React, { useEffect, useState } from "react";
import { useCount } from "../../customHooks/useCount";
import { getTotalCost, setDiscountPrice } from "../../utils/goods";
import { routes } from "../../const/routes";
import { getCurrentPrice } from "../../utils/date";
import { useNavigate } from "react-router-dom";
import { Grommet } from "grommet";
import {
  StyledBox,
  StyledBtnWrap,
  StyledButton,
  StyledButtonCart,
  StyledCheckBox,
  StyledCheckboxWrap,
  StyledCount,
  StyledInfo,
  StyledInfoCount,
  StyledInfoParagraph,
  StyledInfoText,
  StyledNextPrice,
  StyledParagraph,
  StyledPrice,
  StyledTotalPrice,
  StyledWrapper,
} from "./styles";

var BuyEventInfo = function BuyEventInfo(_ref) {
  var format = _ref.format,
    logo = _ref.logo,
    id = _ref.id,
    promocode = _ref.promocode,
    getPromocode = _ref.getPromocode,
    isCertificate = _ref.isCertificate,
    addShop = _ref.addShop,
    loadTickets = _ref.loadTickets,
    allTickets = _ref.allTickets;
  var insurance_available = format.insurance_available,
    insurance_cost = format.insurance_cost,
    price = format.price,
    tickets_left = format.tickets_left,
    event_public_id = format.event_public_id,
    public_id = format.public_id,
    prices = format.prices;
  var min_count = 1;

  if (format.team_all) {
    min_count = format.max_count;
  }

  var navigate = useNavigate();

  var _useState = useState(JSON.parse(localStorage.getItem("userObj"))),
    userObj = _useState[0];

  var _useState2 = useState(false),
    insurance = _useState2[0],
    setInsurance = _useState2[1];

  var _useCount = useCount(min_count),
    count = _useCount[0],
    increment = _useCount[1],
    decrement = _useCount[2];

  var usedTicket = allTickets.find(function (el) {
    return el.event_format.public_id === public_id;
  });
  var isVipUser = (userObj == null ? void 0 : userObj.role) === "vip";
  var discount = userObj == null ? void 0 : userObj.discount;
  var discount_form = userObj == null ? void 0 : userObj.discount_form;

  var handleChangeInsurance = function handleChangeInsurance() {
    return setInsurance(!insurance);
  };

  var handleBasketClick = function handleBasketClick() {
    var totalCost =
      isVipUser && usedTicket === undefined && !isCertificate
        ? getTotalCost(
            setDiscountPrice(price, discount, discount_form),
            count,
            insurance && insurance_cost
          ) + getTotalCost(price, count - 1, insurance && insurance_cost)
        : getTotalCost(price, count, insurance && insurance_cost);

    var sendObj = _extends({}, format, {
      selector: isCertificate ? "certificate" : "ticket",
      logo: logo,
      totalCost: totalCost,
      event_public_id: event_public_id,
      insurance: insurance,
      format_public_id: public_id,
      count: count,
      promocode: null,
    });

    if (!isCertificate && promocode) {
      var codeInfo = _extends(
        {
          code: promocode,
          selector: "ticket",
          format_public_id: public_id,
        },
        format
      );

      getPromocode(codeInfo);
    }

    addShop(sendObj);
    navigate(routes.basket.path);
  };

  useEffect(
    function () {
      if (isVipUser && !allTickets.length) {
        loadTickets();
      }
    },
    [isVipUser, allTickets]
  );
  return /*#__PURE__*/ React.createElement(
    Grommet,
    {
      theme: {
        checkBox: {
          check: {
            radius: "50px",
          },
          color: "black",
        },
      },
    },
    /*#__PURE__*/ React.createElement(
      StyledWrapper,
      null,
      /*#__PURE__*/ React.createElement(
        StyledParagraph,
        null,
        "\u041E\u0441\u0442\u0430\u043B\u043E\u0441\u044C \u0431\u0438\u043B\u0435\u0442\u043E\u0432:\xA0",
        /*#__PURE__*/ React.createElement("span", null, tickets_left)
      ),
      /*#__PURE__*/ React.createElement(
        StyledInfo,
        null,
        insurance_available &&
          /*#__PURE__*/ React.createElement(
            "div",
            null,
            /*#__PURE__*/ React.createElement(
              StyledInfoParagraph,
              null,
              "\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u043A\u0430"
            ),
            /*#__PURE__*/ React.createElement(
              StyledCheckboxWrap,
              null,
              /*#__PURE__*/ React.createElement(StyledCheckBox, {
                id: "check-" + id,
                onChange: handleChangeInsurance,
                label:
                  "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u043E\u0439 \u043F\u043E\u043B\u0438\u0441",
              }),
              /*#__PURE__*/ React.createElement(
                StyledInfoText,
                null,
                "(\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u043A\u0430 \u0434\u043B\u044F \u043B\u0438\u0446 18+)"
              )
            )
          ),
        /*#__PURE__*/ React.createElement(
          StyledBox,
          null,
          /*#__PURE__*/ React.createElement(
            StyledInfoCount,
            null,
            "\u041A\u043E\u043B-\u0432\u043E"
          ),
          /*#__PURE__*/ React.createElement(
            StyledBtnWrap,
            null,
            /*#__PURE__*/ React.createElement(
              StyledButton,
              {
                type: "button",
                onClick: decrement,
              },
              "-"
            ),
            /*#__PURE__*/ React.createElement(StyledCount, null, count),
            /*#__PURE__*/ React.createElement(
              StyledButton,
              {
                type: "button",
                onClick: increment,
              },
              "+"
            )
          )
        ),
        /*#__PURE__*/ React.createElement(
          StyledPrice,
          null,
          /*#__PURE__*/ React.createElement(
            StyledInfoCount,
            null,
            "\u0418\u0442\u043E\u0433\u043E:"
          ),
          /*#__PURE__*/ React.createElement(
            StyledTotalPrice,
            null,
            getTotalCost(price, count, insurance && insurance_cost),
            "\xA0\u20BD"
          ),
          getCurrentPrice(prices) &&
            /*#__PURE__*/ React.createElement(
              StyledNextPrice,
              null,
              "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0446\u0435\u043D\u0430: ",
              getCurrentPrice(prices).price,
              " \u20BD"
            )
        )
      ),
      /*#__PURE__*/ React.createElement(
        StyledButtonCart,
        {
          onClick: handleBasketClick,
          disabled: count > tickets_left,
        },
        "\u0412 \u043A\u043E\u0440\u0437\u0438\u043D\u0443"
      )
    )
  );
};

export default BuyEventInfo;
